import { differenceInSeconds, format, formatDistanceToNow, intervalToDuration, isToday, isYesterday } from 'date-fns';
import { t } from 'i18next';
var ONE_DAY_IN_SECONDS = 86400;
export var months = [
    'months.january',
    'months.february',
    'months.march',
    'months.april',
    'months.may',
    'months.june',
    'months.july',
    'months.august',
    'months.september',
    'months.october',
    'months.november',
    'months.december'
];
export var formatLastActivity = function (lastActivity) {
    if (!lastActivity) {
        return '';
    }
    var activityDate = new Date(lastActivity);
    if (isToday(activityDate) ||
        differenceInSeconds(new Date(), activityDate) < ONE_DAY_IN_SECONDS) {
        var timeAgo = formatDistanceToNow(activityDate, { addSuffix: true });
        return timeAgo;
    }
    if (isYesterday(activityDate)) {
        return t('date.yesterday');
    }
    return format(activityDate, 'MMMM d, yyyy');
};
export var toISODate = function (date) { return format(new Date(date), 'yyyy-MM-dd'); };
export var secondsToHours = function (seconds) {
    return Number((seconds / 3600).toFixed(2));
};
export var formatTime = function (seconds) {
    var duration = intervalToDuration({ start: 0, end: seconds * 1000 });
    var hours = duration.hours ? "".concat(duration.hours, "h") : '';
    var mins = duration.minutes ? "".concat(duration.minutes, "m") : '';
    return "".concat(hours).concat(mins) || '0m';
};
